import { Action, Core } from "@faire/slate/foundation/color";

export const linkHoverColor = Action.text.hover;
export const topBarBackgroundColor = Core.surface.primaryInverse;
